import axios from 'axios';

import {
  ItemConfiguration,
  PickingArea,
  PickingAreaBatchUpdateResponse,
  PickingAreaItem,
  PickingAreasSearchResult,
} from './types';

const pickerApi = axios.create({
  baseURL: process.env.PICKER_API_URI,
});

export const getItemConfigurations = (menuId: string): Promise<ItemConfiguration[]> =>
  pickerApi.get<ItemConfiguration[]>(`/v1/item-configurations?menuId=${menuId}`).then(response => response.data);

export const updateItemConfiguration = (itemConfig: ItemConfiguration): Promise<ItemConfiguration> =>
  pickerApi.put<ItemConfiguration>('/v1/item-configurations', itemConfig).then(response => response.data);

export const bulkUpdateItemConfigurations = (bulkItemConfigs: ItemConfiguration[]): Promise<ItemConfiguration[]> =>
  pickerApi.put<ItemConfiguration[]>('/v1/item-configurations/batch', bulkItemConfigs).then(response => response.data);

export const getPickingAreas = (venueId: string) =>
  pickerApi.get<{ data: PickingArea[] }>(`/v1/venues/${venueId}/picking-areas`).then(res => res.data.data);

export const createPickingAreas = (venueId: string, payload: { name: string }[]) =>
  pickerApi
    .post<{ data: PickingArea[] }>(`/v1/venues/${venueId}/picking-areas`, { data: payload })
    .then(res => res.data);

export const updatePickingAreas = (venueId: string, payload: { id: string; name?: string; order?: number }[]) =>
  pickerApi
    .patch<{ data: PickingArea[] }>(`/v1/venues/${venueId}/picking-areas`, { data: payload })
    .then(res => res.data.data);

export const deletePickingAreas = (venueId: string, areaIds: string[]) =>
  pickerApi.delete(`/v1/venues/${venueId}/picking-areas`, { data: { data: areaIds } });

export const getItemsInPickingArea = (venueId: string, areaId: string) =>
  pickerApi
    .get<{ data: PickingAreaItem[] }>(`/v1/venues/${venueId}/picking-areas/${areaId}/items`)
    .then(res => res.data.data);

export const assignItemsToPickingArea = (venueId: string, areaId: string, itemIds: string[]) =>
  pickerApi.post(`/v1/venues/${venueId}/picking-areas/${areaId}/items`, { data: itemIds });

export const unassignItemsFromArea = (venueId: string, areaId: string, itemIds: string[]) =>
  pickerApi.delete(`/v1/venues/${venueId}/picking-areas/${areaId}/items`, { data: { data: itemIds } });

export const updateItemsInPickingArea = (venueId: string, areaId: string, payload: { id: string; order: number }[]) =>
  pickerApi.patch(`/v1/venues/${venueId}/picking-areas/${areaId}/items`, { data: payload });

export const searchItemsInPickingAreas = (
  venueId: string,
  criteria: { pickingArea?: string; items?: string[]; query?: string },
) =>
  pickerApi
    .post<PickingAreasSearchResult>(`/v1/venues/${venueId}/picking-areas/search`, { criteria })
    .then(res => res.data);

export const bulkUpdatePickingAreas = (
  venueId: string,
  data: { itemId: string; pickingAreaName: string | null; order: number | null }[],
) =>
  pickerApi
    .put<PickingAreaBatchUpdateResponse>(`/v1/venues/${venueId}/picking-routes`, { data })
    .then(response => response.data);

export default pickerApi;
